/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferredClientRequest
 */
export interface UpdateReferredClientRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredClientRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredClientRequest
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredClientRequest
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredClientRequest
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredClientRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredClientRequest
     */
    countryCode: string;
}

/**
 * Check if a given object implements the UpdateReferredClientRequest interface.
 */
export function instanceOfUpdateReferredClientRequest(value: object): value is UpdateReferredClientRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function UpdateReferredClientRequestFromJSON(json: any): UpdateReferredClientRequest {
    return UpdateReferredClientRequestFromJSONTyped(json, false);
}

export function UpdateReferredClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferredClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'companyName': json['companyName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'countryCode': json['countryCode'],
    };
}

export function UpdateReferredClientRequestToJSON(value?: UpdateReferredClientRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'companyName': value['companyName'],
        'phoneNumber': value['phoneNumber'],
        'countryCode': value['countryCode'],
    };
}

